import { render } from "./HomeIconColored.vue?vue&type=template&id=a4bc91b0"
import script from "./HomeIconColored.vue?vue&type=script&lang=js"
export * from "./HomeIconColored.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vdzeer/Projects/movesmart-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__